module.exports = __webpack_public_path__ + "img/Tessellate58.f606300b.jpg";